/**
 * What an hour of development on BB counts as (Gordon 2026-11-02: "set the
 * rate to average salary hour rate and source link"): SCB's average monthly
 * salary for software and systems developers (SSYK 2512, "Mjukvaru- och
 * systemutvecklare m.fl.", 55 500 kr, full time, 2024 statistics) over a
 * full-time month of 40 h × 52 weeks ÷ 12 = 173.3 hours. Salary only — no
 * employer fees. Used for every displayed dev cost (Dashboard → Dev Sessions,
 * the public Transparency page, /api/platform/dev-hours); stored per-session
 * `costEur` values were written at the old €150/h and are not shown any more.
 */
export const DEV_MONTHLY_SALARY_SEK = 55_500;
export const DEV_HOURS_PER_MONTH = (40 * 52) / 12;
export const DEV_HOURLY_RATE_SEK = Math.round(DEV_MONTHLY_SALARY_SEK / DEV_HOURS_PER_MONTH); // 320
export const DEV_RATE_SOURCE = {
  url: 'https://www.scb.se/hitta-statistik/sverige-i-siffror/lonesok/Search/?lon=systemutvecklare',
  label: 'SCB Lönesök — Mjukvaru- och systemutvecklare m.fl. (2024)',
  year: 2024,
};

/** Cost of `seconds` of development at the SCB rate, in kronor. */
export const devCostSek = (seconds: number) => (seconds / 3600) * DEV_HOURLY_RATE_SEK;
